(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this._emptyBoard = function() {
            return Array.from({
                length: _this.size
            }, function() {
                return Array(_this.size).fill(0);
            });
        };
        this.field = this._emptyBoard();
        this.score = 0;
        this.status = "idle";
        if (Array.isArray(initialState)) this.field = initialState.map(function(r) {
            return r.slice();
        });
        else if (initialState && Array.isArray(initialState.field)) {
            this.field = initialState.field.map(function(r) {
                return r.slice();
            });
            this.score = Number(initialState.score || 0);
            this.status = initialState.status || "idle";
        }
        this._initialField = this.field.map(function(r) {
            return r.slice();
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "_cloneField",
            value: function _cloneField() {
                var field = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.field;
                return field.map(function(r) {
                    return r.slice();
                });
            }
        },
        {
            key: "_emptyCells",
            value: function _emptyCells() {
                var res = [];
                for(var r = 0; r < this.size; r++){
                    for(var c = 0; c < this.size; c++)if (this.field[r][c] === 0) res.push([
                        r,
                        c
                    ]);
                }
                return res;
            }
        },
        {
            key: "_spawnRandomTile",
            value: function _spawnRandomTile() {
                var empties = this._emptyCells();
                if (!empties.length) return;
                var _empties_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empties[Math.floor(Math.random() * empties.length)], 2), r = _empties_Math_floor[0], c = _empties_Math_floor[1];
                this.field[r][c] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "_transpose",
            value: function _transpose(mat) {
                var t = this._emptyBoard();
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++)t[c][r] = mat[r][c];
                return t;
            }
        },
        {
            key: "_rowsEqual",
            value: function _rowsEqual(a, b) {
                for(var i = 0; i < a.length; i++){
                    if (a[i] !== b[i]) return false;
                }
                return true;
            }
        },
        {
            key: "_has2048",
            value: function _has2048() {
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    if (this.field[r][c] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "_hasMoves",
            value: function _hasMoves() {
                if (this._emptyCells().length) return true;
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    var v = this.field[r][c];
                    if (r + 1 < this.size && this.field[r + 1][c] === v) return true;
                    if (c + 1 < this.size && this.field[r][c + 1] === v) return true;
                }
                return false;
            }
        },
        {
            key: "_compressAndMergeRowLeft",
            value: function _compressAndMergeRowLeft(row) {
                var vals = row.filter(function(x) {
                    return x !== 0;
                });
                var res = [];
                var gained = 0;
                for(var i = 0; i < vals.length; i++)if (vals[i] === vals[i + 1]) {
                    var merged = vals[i] * 2;
                    res.push(merged);
                    gained += merged;
                    i++;
                } else res.push(vals[i]);
                while(res.length < this.size)res.push(0);
                return {
                    row: res,
                    gained: gained
                };
            }
        },
        {
            key: "_moveLeftCore",
            value: function _moveLeftCore(matrix) {
                var newMat = [];
                var totalGained = 0;
                var changed = false;
                for(var r = 0; r < this.size; r++){
                    var _this__compressAndMergeRowLeft = this._compressAndMergeRowLeft(matrix[r]), newRow = _this__compressAndMergeRowLeft.row, gained = _this__compressAndMergeRowLeft.gained;
                    newMat.push(newRow);
                    totalGained += gained;
                    if (!this._rowsEqual(matrix[r], newRow)) changed = true;
                }
                return {
                    matrix: newMat,
                    changed: changed,
                    totalGained: totalGained
                };
            }
        },
        {
            key: "_applyMove",
            value: function _applyMove(result) {
                if (!result.changed) return false;
                this.field = result.matrix;
                if (result.totalGained > 0) this.score += result.totalGained;
                this._spawnRandomTile();
                if (this._has2048()) this.status = "win";
                else if (!this._hasMoves()) this.status = "lose";
                return true;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this._cloneField();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                if (this.status === "running") return "playing";
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "running";
                this._spawnRandomTile();
                this._spawnRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.field = this._initialField.map(function(r) {
                    return r.slice();
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "running") return false;
                var res = this._moveLeftCore(this.field);
                return this._applyMove(res);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "running") return false;
                var reversed = this.field.map(function(r) {
                    return r.slice().reverse();
                });
                var res = this._moveLeftCore(reversed);
                res.matrix = res.matrix.map(function(r) {
                    return r.reverse();
                });
                return this._applyMove(res);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== "running") return false;
                var t = this._transpose(this.field);
                var res = this._moveLeftCore(t);
                res.matrix = this._transpose(res.matrix);
                return this._applyMove(res);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "running") return false;
                var t = this._transpose(this.field).map(function(r) {
                    return r.reverse();
                });
                var res = this._moveLeftCore(t);
                res.matrix = this._transpose(res.matrix.map(function(r) {
                    return r.reverse();
                }));
                return this._applyMove(res);
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$fieldTable = document.querySelector(".game-field");
var $197cd56b15c33885$var$rows = Array.from($197cd56b15c33885$var$fieldTable.querySelectorAll(".field-row"));
var $197cd56b15c33885$var$cells = $197cd56b15c33885$var$rows.map(function(r) {
    return Array.from(r.querySelectorAll(".field-cell"));
});
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$startMsg = document.querySelector(".message-start");
var $197cd56b15c33885$var$winMsg = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMsg = document.querySelector(".message-lose");
var $197cd56b15c33885$var$btn = document.querySelector(".button");
function $197cd56b15c33885$var$setScoreText(str) {
    $197cd56b15c33885$var$scoreEl.textContent = str;
    $197cd56b15c33885$var$scoreEl.setAttribute("value", str);
}
function $197cd56b15c33885$var$renderField() {
    var state = $197cd56b15c33885$var$game.getState();
    for(var r = 0; r < state.length; r++)for(var c = 0; c < state[r].length; c++){
        var td = $197cd56b15c33885$var$cells[r][c];
        var v = state[r][c];
        td.className = "field-cell";
        td.textContent = v ? String(v) : "";
        if (v) td.classList.add("field-cell--".concat(v));
    }
}
function $197cd56b15c33885$var$renderMessages() {
    var st = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$startMsg.classList.add("hidden");
    $197cd56b15c33885$var$winMsg.classList.add("hidden");
    $197cd56b15c33885$var$loseMsg.classList.add("hidden");
    if (st === "idle") $197cd56b15c33885$var$startMsg.classList.remove("hidden");
    if (st === "win") $197cd56b15c33885$var$winMsg.classList.remove("hidden");
    if (st === "lose") $197cd56b15c33885$var$loseMsg.classList.remove("hidden");
}
function $197cd56b15c33885$var$renderScore() {
    var st = $197cd56b15c33885$var$game.getStatus();
    var val = $197cd56b15c33885$var$game.getScore();
    if (st === "idle") $197cd56b15c33885$var$setScoreText("");
    else if (st === "playing" && val === 0) $197cd56b15c33885$var$setScoreText("");
    else $197cd56b15c33885$var$setScoreText(String(val));
}
function $197cd56b15c33885$var$renderAll() {
    $197cd56b15c33885$var$renderField();
    $197cd56b15c33885$var$renderMessages();
    $197cd56b15c33885$var$renderScore();
}
$197cd56b15c33885$var$btn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$btn.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$btn.classList.remove("start");
        $197cd56b15c33885$var$btn.classList.add("restart");
        $197cd56b15c33885$var$btn.textContent = "Restart";
        $197cd56b15c33885$var$renderAll();
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$btn.classList.remove("restart");
        $197cd56b15c33885$var$btn.classList.add("start");
        $197cd56b15c33885$var$btn.textContent = "Start";
        $197cd56b15c33885$var$renderAll();
    }
});
document.addEventListener("keydown", function(e) {
    var st = $197cd56b15c33885$var$game.getStatus();
    if (![
        "playing",
        "running"
    ].includes(st)) return;
    var map = {
        ArrowLeft: function() {
            return $197cd56b15c33885$var$game.moveLeft();
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$game.moveRight();
        },
        ArrowUp: function() {
            return $197cd56b15c33885$var$game.moveUp();
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$game.moveDown();
        }
    };
    var fn = map[e.key];
    if (fn) {
        fn();
        $197cd56b15c33885$var$renderAll();
    }
});
$197cd56b15c33885$var$renderAll();

})();
//# sourceMappingURL=index.8b80943c.js.map
